// extracted by mini-css-extract-plugin
export default {"nav-link-make-my-logo":"TPNyBvx","navLinkMakeMyLogo":"TPNyBvx"};